
import React, { useState, useEffect } from 'react';
import './index.less';
import Nav from '@/components/Nav';
import { Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { getQuestionList } from '@/constants/api';
import useSWR from 'swr';
import moment from 'moment';
import { useOutletContext, useNavigate } from 'react-router-dom';
import { useSetAtom } from 'jotai';
import { loginAtom } from '@/utils/atoms';
import { LoginInfo } from '@/types';

interface DataType {
  key: string;
  name: string;
  age: number;
  address: string;
  tags: string[];
}


const KfTrackIndex = () => {
  const [pageIndex, setPageIndex] = useState(1);
  const [total, setTotal] = useState(0);
  const [list, setList] = useState([]);
  const navigate = useNavigate();
  const setUpdateLogin = useSetAtom(loginAtom);
  const loginInfo: LoginInfo = useOutletContext();
  const customLocale = {
    emptyText: '暂无数据',
  };

  const { data } = useSWR(`${getQuestionList}?pageIndex=${pageIndex}&pageSize=10&gameId=2&isWeGame=true`);

  useEffect(() => {
    if (data?.retCode === 'SUCCESS') {
      setTotal(data.data.total);
      setList(data.data.list);
    }
  }, [data]);

  useEffect(() => {
    if (!Object.keys(loginInfo).length) {
      setUpdateLogin({ isLogin: false, visibleLogin: true });
    }
  }, [loginInfo]);

  const columns: ColumnsType<DataType> = [
    {
      title: '问题编号',
      dataIndex: 'code',
      key: 'code',
    },
    {
      title: '问题类型',
      dataIndex: 'questionsTypeName',
      key: 'questionsTypeName',
    },
    {
      title: '游戏',
      dataIndex: 'gameName',
      key: 'gameName',
    },
    {
      title: '提交时间',
      key: 'createTime',
      dataIndex: 'createTime',
      render: createTime => moment(createTime).format('YYYY年MM月DD日 HH:mm:ss'),
    },
    {
      title: '处理状态',
      key: 'stateName',
      dataIndex: 'stateName',
    },
    {
      title: '操作',
      key: 'action',
      render: record => <div style={{color: '#0884f7', cursor: 'pointer'}} onClick={() => navigate(`/kf/kfTrackDetail?workCode=${record.code}`)}>查看详情</div>,
    },
  ];

  const onChange = (page: number) => {
    setPageIndex(page);
  };

  return (
    <div className='trackBox'>
      <Nav activeMenu="kfCenter"/>
      <div className='trackWarp'>
        <div className='trackContent'>
            <div className='trackContentTable'>
              <h2 className="wgContentTitle">
                <span>您已提交问题处理进度</span>
              </h2>
              <Table locale={customLocale} columns={columns} pagination={{ position: ['bottomCenter'], pageSize: 10, onChange: page => onChange(page), total}} dataSource={list} />
            </div>
        </div>
      </div>
    </div>
  );
};

export default KfTrackIndex;
